import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/brand";
import { BrandHeader } from "@/components/game/BrandHeader";
import { CtaBanner } from "@/components/game/CtaBanner";
import { Footer } from "@/components/game/Footer";
import { Brewing } from "@/components/plan/Brewing";
import { PlanOverview } from "@/components/plan/PlanOverview";
import { ContentCalendar } from "@/components/plan/ContentCalendar";

export default function PlanPage() {
  const { id } = useParams();
  const [plan, setPlan] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let timer;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/plans/${id}`);
        setPlan(data);
        if (data.status === "generating") timer = setTimeout(poll, 3000);
      } catch {
        setNotFound(true);
      }
    };
    poll();
    return () => clearTimeout(timer);
  }, [id]);

  const name = plan?.request?.name;
  return (
    <div data-testid="plan-page" className="overflow-x-hidden">
      <BrandHeader />
      {notFound && <Message testId="plan-not-found" text="We couldn't find this plan." />}
      {plan?.status === "generating" && <Brewing name={name} />}
      {plan?.status === "failed" && <Message testId="plan-failed" text="Our strategist tripped over a cable. Please play again!" />}
      {plan?.status === "ready" && (
        <>
          <PlanOverview plan={plan} />
          <ContentCalendar days={plan.result.days} weeks={plan.result.weeks} />
        </>
      )}
      <CtaBanner name={name} />
      <Footer />
    </div>
  );
}

const Message = ({ text, testId }) => (
  <div data-testid={testId} className="px-6 py-24 text-center">
    <p className="text-2xl font-bold mb-6">{text}</p>
    <Link to="/" data-testid="play-again-link" className="rounded-full bg-[var(--green)] text-[var(--cream)] px-6 py-3 font-semibold">Play again</Link>
  </div>
);
